module.exports = __webpack_public_path__ + "static/media/sell_take_order_make_1.2f0ce4d9.jpg";